import React, { useState, useEffect } from "react";
import styles from "./TemplateHero20.module.css";

const TemplateHero20 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [animating, setAnimating] = useState(false);

  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setAnimating(true);

      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setAnimating(false);
      }, 400);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  if (slides.length === 0) return null;

  const slide = slides[currentSlide];

  return (
    <div className={styles.heroWrapper}>

      {/* LEFT PANEL */}
      <div className={styles.heroLeft}>
        <div className={styles.slideCounter}>
          {String(currentSlide + 1).padStart(2, "0")} /{" "}
          {String(slides.length).padStart(2, "0")}
        </div>

        <h1
          key={`title-${currentSlide}`}
          className={`${styles.title} ${animating ? styles.animating : ""}`}
        >
          {slide.title}
        </h1>

        <p
          key={`sub-${currentSlide}`}
          className={`${styles.subtitle} ${animating ? styles.animating : ""}`}
        >
          {slide.subtitle}
        </p>

        <div className={styles.buttonRow}>
          <button className={styles.primaryBtn}>Explore Packages</button>
          <button className={styles.outlineBtn}>Learn More</button>
        </div>

        {/* DOTS */}
        {slides.length > 1 && (
          <div className={styles.dots}>
            {slides.map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentSlide(i)}
                className={`${styles.dot} ${
                  i === currentSlide ? styles.activeDot : ""
                }`}
              />
            ))}
          </div>
        )}
      </div>

      {/* RIGHT PANEL */}
      <div className={styles.heroRight}>
        <div
          className={`${styles.heroImg} ${
            animating ? styles.animatingImg : ""
          }`}
          style={{ backgroundImage: `url('${slide.image}')` }}
        />

        <div className={styles.badge}>
          <div className={styles.badgeName}>
            {branding?.companyName || "Travel Agency"}
          </div>
          
        </div>
      </div>

    </div>
  );
};

export default TemplateHero20;